module.exports = __webpack_public_path__ + "img/723.47ce627c.png";